import { Box, Button, Table, TableCell, TableFooter, TableRow } from '@mui/material'
import { ArrowLeftIcon } from 'assets/icons/arrow-left'
import { ArrowRightIcon } from 'assets/icons/arrow-right'
import MuiPagination from '@mui/material/Pagination'

type PaginationProps = {
  colSpan: number
  total: number
  page: number
  take: number
  changePage: (val: number) => void
}

export const Pagination = ({ colSpan, total, page, take, changePage }: PaginationProps) => {
  const pages = Math.ceil(total / take)

  return (
    <Table>
      <TableFooter>
        <TableRow>
          <TableCell colSpan={colSpan} sx={{ border: 'none', paddingBottom: 0 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Button
                onClick={() => {
                  changePage(page - 1)
                }}
                disabled={page === 1}
                startIcon={<ArrowLeftIcon />}
                variant="outlined"
                color="secondary"
              >
                Previous
              </Button>

              <MuiPagination
                count={pages}
                page={page}
                hidePrevButton
                siblingCount={2}
                boundaryCount={2}
                hideNextButton
                onChange={(_, num) => {
                  changePage(num)
                }}
                variant="text"
                shape="rounded"
              />

              <Button
                onClick={() => {
                  changePage(page + 1)
                }}
                disabled={page === pages}
                endIcon={<ArrowRightIcon />}
                variant="outlined"
                color="secondary"
              >
                Next
              </Button>
            </Box>
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  )
}
